import React from "react";

export const H2 =
  "font-heading font-700 uppercase leading-[0.98] tracking-[-0.01em] text-espresso";
export const BODY =
  "font-body text-lg md:text-xl leading-[1.75] text-[#241a15]";
export const BODY_DARK =
  "font-body text-lg md:text-xl leading-[1.75] text-gold/85";

export const Section = ({ children, className = "", id, testId }) => (
  <section id={id} data-testid={testId} className={`relative w-full ${className}`}>
    <div className="mx-auto max-w-6xl px-6 md:px-12">{children}</div>
  </section>
);

export const TCard = ({ img, name, lead, ps, dark = false, testId }) => (
  <figure
    data-testid={testId}
    className={`flex h-full flex-col border p-8 ${
      dark ? "border-cognac/40" : "border-cognac/30 bg-white/40"
    }`}
  >
    <div className="mb-6 flex items-center gap-4">
      {img && (
        <img src={img} alt={`Porträt von ${name}`} loading="lazy" className="h-16 w-16 rounded-full object-cover" />
      )}
      <figcaption
        className={`font-heading text-sm font-700 uppercase tracking-[0.2em] ${dark ? "text-gold" : "text-cognac-2"}`}
        style={{ fontWeight: 700 }}
      >
        {name}{" "}
        <span className={`block font-body text-xs normal-case italic tracking-normal ${dark ? "text-white/60" : "text-espresso/60"}`}>
          über unsere Zusammenarbeit
        </span>
      </figcaption>
    </div>
    <blockquote className="space-y-4">
      <p className={`font-body text-lg font-600 italic leading-relaxed md:text-xl ${dark ? "text-gold" : "text-espresso"}`} style={{ fontWeight: 600 }}>
        „{lead}“
      </p>
      {ps.map((p) => (
        <p key={p} className={`font-body text-base leading-[1.7] ${dark ? "text-gold/80" : "text-[#241a15]/85"}`}>
          {p}
        </p>
      ))}
    </blockquote>
  </figure>
);
